"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstructionalStepValidation = void 0;
class InstructionalStepValidation {
    static isValid(enumValue) {
        if (typeof enumValue !== "number")
            return false;
        if (!(0 <= enumValue && enumValue <= 4)) {
            return false;
        }
        return true;
    }
}
exports.InstructionalStepValidation = InstructionalStepValidation;
